import React from 'react'
import { components } from 'react-select'

import LineTimesIcon from 'components/Luxkit/Icons/line/LineTimesIcon'

type Props = React.ComponentProps<typeof components.DropdownIndicator>

function ClearIndicator({ children, ...props }: Props) {
  return (
    <components.DropdownIndicator {...props}>
      <LineTimesIcon size={16}/>
    </components.DropdownIndicator>
  )
}

export default ClearIndicator
